import { PageHeader } from '@/components/PageHeader';
import { EmptyState } from '@/components/EmptyState';

export function StaffPage() {
  return (
    <div>
      <PageHeader title="Staff" description="Staff accounts for the Dome Events desk." />
      <EmptyState title="Staff managed via SQL for now" body="Create the first admin in domeec_staff (PBKDF2 hash) — see OPERATIONS notes." />
    </div>
  );
}
